import type { CSSProperties, HTMLAttributes } from 'react';
import { forwardRef } from 'react';
import styled, { css } from 'styled-components';

type BlockProps = {
  _grow: boolean;
};

export const Block = styled.div<BlockProps>`
  display: flex;
  align-items: center;
  position: relative;

  ${({ _grow }) =>
    _grow &&
    css`
      flex: 1;
    `}
`;

export const RegularBlock = styled(Block)``;
export const OuterBlock = styled(Block)``;
export const ColoredBlock = styled(Block)``;

export type CardBlockProps = HTMLAttributes<HTMLDivElement> & {
  backgroundColor?: string;
  outerMode?: boolean;
  grow?: boolean;
  style?: CSSProperties;
};

export const CardBlock = forwardRef<HTMLDivElement, CardBlockProps>(
  function CardBlock(
    { outerMode, backgroundColor, grow = false, style, ...forwardingProps },
    forwardingRef
  ) {
    if (outerMode) {
      return (
        <OuterBlock
          _grow={grow}
          style={style}
          ref={forwardingRef}
          {...forwardingProps}
        />
      );
    }

    if (backgroundColor) {
      return (
        <ColoredBlock
          _grow={grow}
          style={{
            backgroundColor,
            ...style
          }}
          ref={forwardingRef}
          {...forwardingProps}
        />
      );
    }

    return (
      <RegularBlock
        _grow={grow}
        style={style}
        ref={forwardingRef}
        {...forwardingProps}
      />
    );
  }
);
